import {
  authFetch, buildApiUrl 
} from '@/lib/api-client';
import {
  requisitionsResponseSchema, type RequisitionsResponse, type RequisitionStatus 
} from '../types';
import { ApiClientError } from '@/errors';

export interface RequisitionFilters {
  readonly status?: RequisitionStatus;
  readonly venueId?: string;
}

export async function getRequisitions(siteId: string, filters?: RequisitionFilters): Promise<RequisitionsResponse> {
  const params = new URLSearchParams();
  if (filters?.status) params.set('status', filters.status);
  if (filters?.venueId) params.set('venueId', filters.venueId);

  const url = buildApiUrl(`/v1/sites/${siteId}/requisitions`, params);
  const response = await authFetch(url);
  
  if (!response.ok) {
    throw ApiClientError.fromResponse(response, 'Failed to fetch requisitions');
  }

  const data: unknown = await response.json();
  return requisitionsResponseSchema.parse(data);
}
